import { render } from "./BestiaryCompendiumModal.vue?vue&type=template&id=0360db69&scoped=true"
import script from "./BestiaryCompendiumModal.vue?vue&type=script&lang=js"
export * from "./BestiaryCompendiumModal.vue?vue&type=script&lang=js"

import "./BestiaryCompendiumModal.vue?vue&type=style&index=0&id=0360db69&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0360db69"]])

export default __exports__